import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  AsyncCallArgs,
  BlockText,
  CircularLoader,
  convertDate,
  GridContainer,
  GridItem,
  useAsyncCall,
} from "@duosoftbg/nacid-components";
import { ViewDialog } from "@duosoftbg/nacid-components";
import { getGlobalMessage } from "../../../../../../axios/api/services";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import { closeModal } from "../../../../../../store/redux/slice/ComponentsControl/globalMessageControl";

const ViewGlobalMessageDialog = () => {
  const dispatch = useAppDispatch();
  const { asyncCall } = useAsyncCall();
  const { t } = useTranslation();
  const [globalMessage, setGlobalMessage] = useState(null);

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.globalMessageControl.modals.view;
  });

  const handleCloseDialog = () => {
    dispatch(closeModal({ modalType: "view" }));
  };

  useEffect(() => {
    if (open && id != null) {
      const asyncCallArgs: AsyncCallArgs = {
        promise: getGlobalMessage(id),
        onSuccess: (response) => {
          setGlobalMessage(response);
        },
        onError: () => {
          setGlobalMessage(null);
        },
      };
      asyncCall(asyncCallArgs);
    }
  }, [id, open, asyncCall]);

  return (
    <ViewDialog open={open} onClose={handleCloseDialog} title={"t.global.message.view.dialog"}>
      {!globalMessage && <CircularLoader />}
      {globalMessage && (
        <Fragment key={globalMessage.id + " content"}>
          <GridContainer spacing={5}>
            {globalMessage.name && (
              <GridItem sm={4} md={4}>
                <BlockText label={"l.globalMessage.name"} text={globalMessage.name} />
              </GridItem>
            )}
            {globalMessage.nameEn && (
              <GridItem sm={4} md={4}>
                <BlockText label={"l.globalMessage.nameEn"} text={globalMessage.nameEn} />
              </GridItem>
            )}

            <GridItem sm={4} md={4}>
              <BlockText label={"l.globalMessage.active"} text={globalMessage.active ? t("m.yes") : t("m.no")} />
            </GridItem>
            {globalMessage.createdDate && (
              <GridItem sm={4} md={4}>
                <BlockText label={"l.globalMessage.createdDate"} text={convertDate(globalMessage.createdDate)} />
              </GridItem>
            )}

            {globalMessage.lastUpdateDate && (
              <GridItem sm={4} md={4}>
                <BlockText label={"l.globalMessage.lastUpdateDate"} text={convertDate(globalMessage.lastUpdateDate)} />
              </GridItem>
            )}

            <GridItem sm={4} md={4}>
              <BlockText label={"l.globalMessage.type"} text={globalMessage.type.id} />
            </GridItem>

            {globalMessage.text && (
              <GridItem sm={12} md={12}>
                <BlockText label={"l.globalMessage.text"} text={globalMessage.text} />{" "}
              </GridItem>
            )}
            {globalMessage.textEn && (
              <GridItem sm={12} md={12}>
                <BlockText label={"l.globalMessage.textEn"} text={globalMessage.textEn} />
              </GridItem>
            )}
          </GridContainer>
        </Fragment>
      )}
    </ViewDialog>
  );
};

export default ViewGlobalMessageDialog;
